import dayjs from "@/lib/helpers/dayjs";
import type { NoteDetail } from "@/core/types";

export function formatSignatureDate(note: NoteDetail) {
  return note.completed_date_time
    ? dayjs(note.completed_date_time).format(DATE_FORMAT)
    : note.signature_date;
}

const DATE_FORMAT = "MM/DD/YYYY";
